import { eventCostcenterChanged } from './cam-context-switcher-constants';
import camContextSwitcherDatastore from './cam-context-switcher-datastore';
import CamContextSwitcherCostcenter from './cam-context-switcher-costcenter';

const tagName = 'cam-context-switcher-costcenter-list';
const template = require(`../templates/${tagName}.ejs`);

export default class CamContextSwitcherCostcenterList extends HTMLElement {

  static get observedAttributes() {
    return [ 'selected-organization' ];
  }

  constructor() {
    super();
    this.datastore = camContextSwitcherDatastore;
  }

  connectedCallback() {
    this.classList.add(tagName);

    this.addEventListener(eventCostcenterChanged, this.handleCostcenterChange);

    this.innerHTML = template();
    this.container = this.querySelector('.menu-content');
  }

  disconnectedCallback() {
    this.removeEventListener(eventCostcenterChanged, this.handleCostcenterChange);
  }

  attributeChangedCallback(attrName, oldValue, newValue) {
    if (newValue !== oldValue) {
      this.renderCamCostcenterList(this.datastore.costcenters);
    }
  }

  renderCamCostcenterList(costcenterList) {
    while (this.container.firstChild) {
      this.container.removeChild(this.container.firstChild);
    }
    let selected = !this.datastore.selectedCostcenter;
    let allCostcenters = {
      costcenter: {
        id: null
      },
      display: {
        name: `All (${costcenterList.length})`,
        selected: selected
      }
    };
    let costcenterElement = new CamContextSwitcherCostcenter(allCostcenters);
    this.container.appendChild(costcenterElement);
    costcenterList.forEach((cc) => {
      costcenterElement = new CamContextSwitcherCostcenter(cc);
      this.container.appendChild(costcenterElement);
    });
  }

  handleCostcenterChange(e) {
    e.cancelBubble = true;
    let costcenter = e.detail.costcenter;
    let workspaceList = document.querySelector('cam-context-switcher-workspace-list');

    this.datastore.changeCostcenter(costcenter.id);
    this.renderCamCostcenterList(this.datastore.costcenters);
    workspaceList.setAttribute('selected-costcenter', costcenter.id);
  }


}

customElements.define(tagName, CamContextSwitcherCostcenterList);



// WEBPACK FOOTER //
// ./src/cam-context-switcher/scripts/cam-context-switcher-costcenter-list.js